export enum OverviewType {
  Home = "home",
  Archived = "archived",
  Error = "error",
  Remove = "remove",
  AnnotationTodo = "annotationTodo",
  AnnotationDone = "annotationDone",
}
